import { signOut } from "firebase/auth";
import { auth } from "@/config/firebaseConfig";
import { queryClient } from "@/lib/query-client";
import { appRouter } from "@/routes/Routes";
import {
  IDLE_LOGOUT_REASON_PARAM,
  IDLE_LOGOUT_REASON_VALUE,
  IDLE_LOGOUT_MINUTES_PARAM,
} from "./reason-params";

/**
 * GRA-80: run when the idle timer reaches zero. Signs the user out, clears
 * every cached query (business/user data, chat threads, …) and any local
 * session state, then sends them to sign-in with a reason the login page
 * turns into "Du loggades ut efter 10 minuters inaktivitet".
 *
 * `signOut` is attempted first but the redirect + cache clear always happen
 * (`finally`) — an idle session with a stale/expired token should still land
 * the user back on sign-in rather than getting stuck.
 *
 * `idleLogoutMinutes` is threaded through as a query param (rather than
 * hardcoding "10" in the login page copy) so a future selectable timeout
 * (5/30 minutes) shows the right number without further changes.
 */
export async function performIdleLogout(
  idleLogoutMinutes: number,
): Promise<void> {
  try {
    await signOut(auth);
  } catch (err) {
    console.error("Idle logout: signOut failed", err);
  } finally {
    queryClient.clear();
    const params = new URLSearchParams({
      [IDLE_LOGOUT_REASON_PARAM]: IDLE_LOGOUT_REASON_VALUE,
      [IDLE_LOGOUT_MINUTES_PARAM]: String(idleLogoutMinutes),
    });
    appRouter.navigate(`/sign-in?${params.toString()}`, { replace: true });
  }
}
